import { render, staticRenderFns } from "./PlantSelect.vue?vue&type=template&id=95bf0e34&"
import script from "./PlantSelect.vue?vue&type=script&lang=js&"
export * from "./PlantSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports